import { render, staticRenderFns } from "./newteam.vue?vue&type=template&id=d837da6c&"
import script from "./newteam.vue?vue&type=script&lang=js&"
export * from "./newteam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports